import Button from '@common/Button/Button';
import { Hero } from '@components/Hero/Hero';

import HeroImage from '@public/img/nhs/hero.png';

export const NhsHero = (): JSX.Element => (
  <Hero
    title={<span className="text-blue">Partner with Second Nature</span>}
    description={
      <div className="sm:mb-6">
        <span className="text-mono-white">
          Redefine obesity and diabetes care with comprehensive, evidence-based
          services.
        </span>
      </div>
    }
    image={HeroImage}
    altText="Two women"
    color="bg-salmon"
    placeholder="blur"
    priority
    ctaChildren={[
      <a href="#hearfromyou" key="hear-from-you">
        <Button colour="NavyBlue" type="Primary">
          Request more information
        </Button>
      </a>,
    ]}
  />
);
